import { ControlledRadioButton } from '@@viewCommonComponents/controlled';
import booleanOptions from '@@viewCommonComponents/forms/options';
import {
  CFE_REPRESENTATIVE_OFFER_CODES,
  CFE_REPRESENTATIVE_QUESTION_LABEL
} from '@@custom/mhexpat/__custom/constants/cfeRepresentative.mjs';

const SouscriptionCustomerExtraFormCfeRepresentative = ({ form, offerCode }) => {
  if (!CFE_REPRESENTATIVE_OFFER_CODES.includes(offerCode)) return null;

  return (
    <ControlledRadioButton
      containerClassName="w-full"
      label={CFE_REPRESENTATIVE_QUESTION_LABEL}
      id="cfeContributionsPaidByRepresentative"
      name="cfeContributionsPaidByRepresentative"
      defaultValue={false}
      booleanValue
      form={form}
      options={booleanOptions}
      data-testid="ADHERENT_COTISATIONS_CFE_PAYEES_PAR_MANDATAIRE"
      disabled
    />
  );
};

export default SouscriptionCustomerExtraFormCfeRepresentative;
